import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import WorkplaceHealthPlans from './WorkplaceHealthPlans';

loadDOMComponent({
	selector: 'react-workplace-health-plans',
	callback: ({ container, context }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const openCaseTypes = container.getAttribute('openCaseTypes');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<WorkplaceHealthPlans
							workplaceId={workplaceId}
							openCaseTypes={openCaseTypes}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
